export default __webpack_public_path__ + "static/media/noData.e6359f53.png";